export const SET_WALLETS = 'FINANCE/SET_WALLETS'
export const SET_WALLET_TRANSACTIONS = 'FINANCE/SET_WALLET_TRANSACTIONS'
export const SET_WALLET_NAME = 'FINANCE/SET_WALLET_NAME'
export const FETCH_WALLETS = 'FINANCE/FETCH_WALLETS'
export const CHANGE_ACTIVE_WALLET_ID = 'FINANCE/CHANGE_ACTIVE_WALLET_ID'
export const FETCH_WALLET_TRANSACTIONS = 'FINANCE/FETCH_WALLET_TRANSACTIONS'
export const RESET_WALLETS = 'FINANCE/RESET_WALLETS'
export const RESET_WALLETS_FILTERS = 'FINANCE/RESET_WALLETS_FILTERS'
export const SET_WALLETS_FILTERS = 'FINANCE/SET_WALLETS_FILTERS'
export const RESET_WALLET_TRANSACTIONS = 'FINANCE/RESET_WALLET_TRANSACTIONS'
